import type { QuoteDetailPublic } from "@common/client"
import { useHasPermission } from "@common/hooks/use-permissions"

export function useDetailsEditable(): boolean {
  return useHasPermission("quote:update")
}

export function useEditable(quote: QuoteDetailPublic): boolean {
  const canUpdate = useHasPermission("quote:update")
  const canReview = useHasPermission("quote:review")
  if (!canUpdate) return false
  switch (quote.disposition) {
    case "draft":
      return true
    case "review":
    case "customer_response":
      return canReview
    case "customer_review":
    case "won":
    case "lost":
    case "cancelled":
    case "expired":
      return false
  }
}
